import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LoginService } from '../pages/login/login.service';
import { setCognitoToken, setLoggedInUser } from '../Store/request.actions';
import { setCognitoTokenHolder } from '../Store/cognito-token.holder';

const REFRESH_INTERVAL_MS = 30 * 60 * 1000;

// The chatbot's Cognito token is cached in cognito-token.holder.ts and is only
// otherwise refreshed when AuthGuard re-fires, which SPA navigation between
// child routes does not trigger. Without this, an idle-but-logged-in broker's
// cached token expires and every chatbot request starts 401ing. If the backend
// session itself has expired/been revoked by the time we refresh, redirect to
// login the same way AuthGuard does.
@Injectable({
  providedIn: 'root',
})
export class CognitoTokenRefreshService {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private loginService: LoginService, private store: Store, private router: Router) {}

  start(): void {
    if (this.intervalId !== null) {
      return;
    }
    this.intervalId = setInterval(() => this.refresh(), REFRESH_INTERVAL_MS);
  }

  private refresh(): void {
    if (!localStorage.getItem('token')) {
      return;
    }

    this.loginService.checkLogin().subscribe({
      next: (response: any) => {
        if (response.status === 'authenticated') {
          this.store.dispatch(setCognitoToken({ cognitoToken: response.cognitoToken }));
          setCognitoTokenHolder(response.cognitoToken);
        } else {
          this.handleUnauthenticated();
        }
      },
      error: () => {
        this.handleUnauthenticated();
      },
    });
  }

  private handleUnauthenticated(): void {
    this.store.dispatch(setLoggedInUser({ request: null }));
    this.store.dispatch(setCognitoToken({ cognitoToken: null }));
    setCognitoTokenHolder(null);
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}
